// removed by extract-text-webpack-plugin
module.exports = {"calendar-navigation":"src-modules-accommodation-AccommodationCalendarView-__AccommodationCalendarView__calendar-navigation--WVQ_z"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/accommodation/AccommodationCalendarView/AccommodationCalendarView.less
// module id = 1868
// module chunks = 0